/* src/app/components/notification/notification-details/comment/sub-comment/sub-comment.component.scss */
.media-content {
  width: 90% !important;
  overflow-x: hidden;
}
.media-content .edit-text-box .text-input {
  width: 100% !important;
}
::ng-deep .empty-head-icon {
  padding-top: 5px !important;
  background-image:
    linear-gradient(
      to top,
      #accbee 0%,
      #e7f0fd 100%) !important;
}
/*# sourceMappingURL=sub-comment.component.css.map */
